import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import Vue from 'vue'

// initial state
const state = {
  rechnungen: [],
  eigeneRechnungen: [],
  loading: false,
  loaded: false,
  loadedEigene: false,
  error: null
}

// getters
const getters = {
  rechnungen (state) {
    return state.rechnungen
  },
  nutzerRechnungen: (state) => (user) => {
    let rechnungen = []
    if (state.rechnungen.length > 0) {
      state.rechnungen.forEach(rechnung => {
        if (rechnung.bbrID === user) {
          rechnungen.push(rechnung)
        }
      })
    } else {
      state.eigeneRechnungen.forEach(rechnung => {
        if (rechnung.bbrID === user) {
          rechnungen.push(rechnung)
        }
      })
    }
    return rechnungen
  },
  nutzerRechnungenOffen: (state) => (user) => {
    let rechnungen = []
    state.eigeneRechnungen.forEach(rechnung => {
      if ((rechnung.bbrID === user) && ((rechnung.status === 'Offen') || (rechnung.status === 'Überfällig'))) {
        rechnungen.push(rechnung)
      }
    })
    return rechnungen
  },
  statusRechnungenKasse: (state) => (status, kasse) => {
    let rechnungen = []
    state.rechnungen.forEach(rechnung => {
      if ((rechnung.status === status) && (rechnung.kasse === kasse)) {
        rechnungen.push(rechnung)
      }
    })
    return rechnungen
  },
  statusRechnungenLetztesDatum: (state) => (kasse) => {
    let rechnungen = []
    if (state.rechnungen.length > 0) {
      let datum = state.rechnungen[0].rechnung_datum
      state.rechnungen.forEach(rechnung => {
        if (rechnung.rechnung_datum) {
          if ((rechnung.rechnung_datum === datum) && (rechnung.kasse === kasse)) {
            rechnungen.push(rechnung)
          }
        } else {
          console.log(rechnung)
        }
      })
    }
    return rechnungen
  },
  rechnungenKasse: (state) => (kasse) => {
    let rechnungen = []
    state.rechnungen.forEach(rechnung => {
      if (rechnung.kasse === kasse) {
        rechnungen.push(rechnung)
      }
    })
    return rechnungen
  },
  statusRechnungen: (state) => (status) => {
    let rechnungen = []
    state.rechnungen.forEach(rechnung => {
      if (rechnung.status === status) {
        rechnungen.push(rechnung)
      }
    })
    return rechnungen
  },
  nutzerRechnung: (state) => (id) => {
    return state.eigeneRechnungen.find(rechnung => rechnung.id === id)
  },
  rechnung: (state) => (id) => {
    return state.rechnungen.find(rechnung => rechnung.id === id)
  },
  rechnungNummer: (state) => (nummer) => {
    return state.rechnungen.find(rechnung => rechnung.rechnungsnummer === nummer)
  },
  loading (state) {
    return state.loading
  },
  error (state) {
    return state.error
  }
}

// actions
const actions = {
  loadRechnungen ({commit}) {
    commit('setLoading', true)
    console.log('Rechnungen laden...')
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('rechnungen').orderBy('rechnung_datum', 'desc')
    .onSnapshot(snapshot => {
      const rechnungen = []
      snapshot.forEach(doc => {
        rechnungen.push({
          ...doc.data(),
          id: doc.id
        })
        commit('setLoadedRechnungen', rechnungen)
        commit('setLoading', false)
        commit('setLoaded', true)
      })
    }, (error) => {
      console.log(error)
      commit('setLoading', false)
    })
  },
  loadEigeneRechnungen ({commit}, user) {
    commit('setLoading', true)
    console.log('Eigene Rechnungen laden...')
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('rechnungen').where('bbrID', '==', user.user)
    .onSnapshot(snapshot => {
      const rechnungen = []
      snapshot.forEach(doc => {
        rechnungen.push({
          ...doc.data(),
          id: doc.id
        })
        commit('setLoadedEigeneRechnungen', rechnungen)
        commit('setLoading', false)
        commit('setLoadedEigene', true)
      })
    }, (error) => {
      console.log(error)
      commit('setLoading', false)
    })
  },
  createRechnung ({commit, getters}, payload) {
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('rechnungen').add(payload)
      .then(key => {
        // let summe = 0
        // payload.positionen.forEach(position => {
        //   summe = parseFloat(summe) + parseFloat(position.betrag)
        // })
        // commit('createRechnung', {
        //   ...payload,
        //   summe,
        //   id: key.id
        // })
      })
      .catch((error) => {
        console.log(error)
      })
  // Reach out to firebase and store it
  },
  deleteRechnungData ({commit}, payload) {
    commit('setLoading', true)
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('rechnungen').doc(payload).delete()
    .then(() => {
      commit('setLoading', false)
      commit('deleteRechnung', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
    commit('setLoading', false)
  },
  updateRechnungData ({commit}, payload) {
    commit('setLoading', true)
    const updateObj = {}
    Object.keys(payload).forEach(key => {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key]
      }
    })
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('rechnungen').doc(payload.id).update(updateObj)
    .then(() => {
      commit('setLoading', false)
      commit('updateRechnung', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
  }
}

// mutations
const mutations = {
  setLoadedRechnungen (state, payload) {
    state.rechnungen = payload
  },
  setLoadedEigeneRechnungen (state, payload) {
    state.eigeneRechnungen = payload
  },
  createRechnung (state, payload) {
    state.rechnungen.push(payload)
  },
  updateRechnung (state, payload) {
    const rechnung = state.rechnungen.find(rechnung => {
      return rechnung.id === payload.id
    })
    Object.keys(payload).forEach(key => {
      if (payload[key]) {
        rechnung[key] = payload[key]
      }
    })
  },
  deleteRechnung (state, payload) {
    let array = state.rechnungen
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1)
      }
    }
    state.rechnungen = array
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setLoaded (state, payload) {
    state.loaded = payload
  },
  setLoadedEigene (state, payload) {
    state.loadedEigene = payload
  },
  setError (state, payload) {
    state.error = payload
  },
  clearError (state) {
    state.error = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/rechnungen_alt.js